<template>
  <v-menu
    bottom
    left
    min-width="200"
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        class="ml-2"
        min-width="0"
        text
        v-bind="attrs"
        v-on="on"
        @click="logout"
      >
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </template>
  </v-menu>
</template>

<script>
import axios from 'axios';
export default {
  name: 'DefaultAccount',
  methods: {
    async logout() {
      await axios.post(`auth/logout`)
        .then(res => {
          localStorage.clear();

          this.$router.push('/login');
        })
        .catch(err => {
          alert(err.response.data.message);
        }); 
    }
  }
}
</script>
